<template>
  <div class="api-integrations-tab">
    <ApiTabEmptyState
      title="No integrations yet"
      description="Create an integration to get a client ID and secret, then exchange them for tokens using the OAuth 2.0 flow."
      create-cta-text="Create integration"
      :icon="['fak', 'integration']"
    />
  </div>
</template>

<script setup lang="ts">
import { useHead } from '@unhead/vue';

import ApiTabEmptyState from '../components/ApiTabEmptyState.vue';

useHead({ title: 'API Integrations - Crossbeam' });
</script>
